var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueuePostpone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4 24H7V21C7 18.3 11.24 17 13.4 17C13.88 17 14.44 17.1 15.08 17.2C14.92 17.8 15 18.5 15.16 19.1C14.6 19 13.96 18.9 13.4 18.9C11 18.9 9 20.4 9 21V22.1H17L17.4 22.7V24Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C12.575 8 11 9.575 11 11.5C11 13.425 12.575 15 14.5 15C16.425 15 18 13.425 18 11.5C18 9.575 16.425 8 14.5 8ZM14.5 13.25C13.5375 13.25 12.75 12.4625 12.75 11.5C12.75 10.5375 13.5375 9.75 14.5 9.75C15.4625 9.75 16.25 10.5375 16.25 11.5C16.25 12.4625 15.4625 13.25 14.5 13.25Z",
    fill: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15C18.575 15 17 16.575 17 18.5C17 20.425 18.575 22 20.5 22C22.425 22 24 20.425 24 18.5C24 16.575 22.425 15 20.5 15ZM18.995 19.725L18.75 19.27L20.15 18.465V16.75H20.675V18.78L18.995 19.725Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuePostpone);
export default __webpack_public_path__ + "static/media/queue_postpone.409215670b9398b83c5f3291eb0c8a62.svg";
export { ForwardRef as ReactComponent };